//1.引入对应模块
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import Home from './../pages/Home/Home'
import Solution from './../pages/Solution/Solution'
import Solution1 from './../pages/Solution1/Solution1'
import SolutionContent from './../pages/SolutionContent/SolutionContent'
import About from './../pages/About/About'
import News from './../pages/News/News'
import NewsContent from './../pages/NewsContent/NewsContent'
import Cooperation from './../pages/Cooperation/Cooperation'
import Product from './../pages/Product/Product'
import Search from './../pages/Product/Search'
import Details from './../pages/Product/Details'
import Courses from './../pages/Home/Courses'
import JoinDetails from '../pages/Join/JoinDetails'
import User from '../pages/User/User'
import UserService from '../pages/User/UserService'
import UserAppointment from '../pages/User/UserAppointment'
import UserChange from '../pages/User/UserChange'
import UserForget from '../pages/Login/UserForget'
import UserInfo from '../pages/User/UserInfo'
import UserRecord from '../pages/User/UserRecord'
import SingleService from '../pages/User/SingleService'
import SingleRecord from '../pages/User/SingleRecord'
import Login from '../pages/Login/Login'
const vipList=['/user','/user/service','/user/appointment','/user/change','/user/record','/user/singleService','/user/singleRecord']

// const login = r => require.ensure([],() => r(require('./../page/login')),'login');
// const Home = r => require.ensure([],() => r(require('./../pages/Home/Home')),'Home');
// const Solution = r => require.ensure([],() => r(require('./../pages/Solution/Solution')),'Solution');
// const Solution1 = r => require.ensure([],() => r(require('./../pages/Solution1/Solution1')),'Solution1');
// const SolutionContent = r => require.ensure([],() => r(require('./../pages/SolutionContent/SolutionContent')),'SolutionContent');
// const About = r => require.ensure([],() => r(require('./../pages/About/About')),'About');
// const News = r => require.ensure([],() => r(require('./../pages/News/News')),'News');
// const NewsContent = r => require.ensure([],() => r(require('./../pages/NewsContent/NewsContent')),'NewsContent');
// const Cooperation = r => require.ensure([],() => r(require('./../pages/Cooperation/Cooperation')),'Cooperation');

//2.声明使用
Vue.use(VueRouter)
//3.
let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/home',
            component: Home
        },
        {
            path: '/home/courses',
            component: Courses
        },
        {
            path: '/solution',
            component: Solution
        },
        {
            path: '/solution1',
            component: Solution1
        },
        {
            path: '/SolutionContent',
            component: SolutionContent
        },
        {
            path: '/about',
            component: About
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/newsContent/:id',
            name: 'NewsContent',
            component: NewsContent
        },
        {
            path: '/cooperation',
            component: Cooperation
        },
        {
            path: '/product',
            component: Product,
        },
        {
            path: '/product/search',
            component: Search
        },
        {
            path: '/product/details',
            component: Details
        },
        {
            path: '/join/details',
            component: JoinDetails,
        },
        {
            path: '/login',
            component: Login,
        },
        {
            path: '/user/forget',
            component: UserForget,
        },
        {
            path: '/user',
            component: User,
            children: [
                {
                    path: '/user/service',
                    component: UserService,
                },
                {
                    path: '/user/appointment',
                    component: UserAppointment,
                },
                {
                    path: '/user/change',
                    component: UserChange,
                },

                {
                    path: '',
                    component: UserInfo,
                },
                {
                    path: '/user/record',
                    component: UserRecord,
                },
                {
                    path: '/user/singleService',
                    component: SingleService,
                },
                {
                    path: '/user/singleRecord',
                    component: SingleRecord,
                },
            ]
        },
        {
            path: '/',
            redirect: '/home'
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})
router.beforeEach((to,from,next)=>{
    const mobile=store.state.mobile
    if(!mobile&&vipList.includes(to.path)){
        next('/login?backto='+encodeURIComponent(to.path))
    }
    // else if(mobile&&to.path==='/login'){
    //     next('/')
    // }
    else{
        next()
    }
})
export default router